import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import el from '../locales/el.json'

export default createI18n({
  legacy: false, // for composition API support
  locale: 'en',  // default language
  fallbackLocale: 'en',
  messages: {
    en,
    el
  }
})
